/* Auto-generated from home_pretext_mobile.html. Do not edit by hand. */
export default function HomeMobilePretext() {
  return (
    <>
      <div className={"framer-y8x7k9 hidden-iwl1xz hidden-1ybsehl"} data-home-mobile-pretext={"true"} data-border={"true"} data-framer-name={"PRETEXT"}>
  <div className={"framer-rt0tn4"} data-border={"true"}>
    <div className={"framer-qkda59"} data-border={"true"} data-framer-appear-id={"qkda59"} data-framer-name={"PRETEXT"} style={{ opacity: 1, transform: "none" }}>
      <div className={"framer-ya26mg"} data-border={"true"}>
        <div className={"framer-1apu7sj"}>
          <div className={"framer-pwafh2"} aria-hidden={"true"}>
            <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
              <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg801605881_263"}></use></svg>
            </div>
          </div>
        </div>
        <div className={"framer-111kiyc"}>
          <div className={"framer-170j8r0"} aria-hidden={"true"}>
            <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
              <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg1753402167_263"}></use></svg>
            </div>
          </div>
        </div>
        <div className={"framer-1o483si"}>
          <div className={"framer-bv4tck"} aria-hidden={"true"} style={{ transform: "rotate(-90deg)" }}>
            <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
              <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg801605881_263"}></use></svg>
            </div>
          </div>
        </div>
        <div className={"framer-rl203z"}>
          <div className={"framer-zseeyd"} aria-hidden={"true"} style={{ transform: "rotate(-90deg)" }}>
            <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
              <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg-768992073_263"}></use></svg>
            </div>
          </div>
        </div>
        <div className={"framer-1ka39ao"} data-border={"true"}>
          <div className={"framer-14nbzcp"}>
            <div className={"framer-1gruckc"} aria-hidden={"true"}>
              <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
                <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg801605881_263"}></use></svg>
              </div>
            </div>
          </div>
          <div className={"framer-iztda1"}>
            <div className={"framer-4s1azl"} aria-hidden={"true"}>
              <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
                <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg1753402167_263"}></use></svg>
              </div>
            </div>
          </div>
          <div className={"framer-1qobs3b"}>
            <div className={"framer-1yahszn"} aria-hidden={"true"} style={{ transform: "rotate(-90deg)" }}>
              <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
                <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg801605881_263"}></use></svg>
              </div>
            </div>
          </div>
          <div className={"framer-ugfy0s"}>
            <div className={"framer-14x6xjx"} aria-hidden={"true"} style={{ transform: "rotate(-90deg)" }}>
              <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
                <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg-768992073_263"}></use></svg>
              </div>
            </div>
          </div>
          <div className={"framer-myk745"} data-framer-appear-id={"myk745"} data-framer-component-type={"RichTextContainer"} style={{ opacity: 1, transform: "none" }}>
            <p className={"framer-text"} style={{ "--font-selector": "R0Y7R2Vpc3QgTW9uby1yZWd1bGFy", "--framer-font-family": "\"Geist Mono\", monospace", "--framer-font-size": "calc(1rem * 1)", "--framer-letter-spacing": "-0.005em", "--framer-line-height": "1.6em", "--framer-text-alignment": "center", "--framer-text-color": "rgba(255, 255, 255, 0.8)", "--framer-text-transform": "uppercase" }}>Lighter is a zero-knowledge rollup on top of Ethereum optimized for speed, throughput and scale that generates ZK proofs of all operations including order matching and liquidations.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className={"framer-8y0rtm"}>
    <div className={"framer-gf333"} aria-hidden={"true"}>
      <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
        <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg1348121721_263"}></use></svg>
      </div>
    </div>
  </div>
  <div className={"framer-1euzy98"}>
    <div className={"framer-1byvftm"} aria-hidden={"true"}>
      <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
        <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg-1043253003_263"}></use></svg>
      </div>
    </div>
  </div>
  <div className={"framer-1gz1v0o"}>
    <div className={"framer-1vs5bc6"} aria-hidden={"true"} style={{ transform: "rotate(-90deg)" }}>
      <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
        <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg1348121721_263"}></use></svg>
      </div>
    </div>
  </div>
  <div className={"framer-eoj5eo"}>
    <div className={"framer-15pcnjs"} aria-hidden={"true"} style={{ transform: "rotate(-90deg)" }}>
      <div className={"svgContainer"} style={{ width: "100%", height: "100%", aspectRatio: "inherit" }}>
        <svg style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg-1793074187_263"}></use></svg>
      </div>
    </div>
  </div>
</div>

    </>
  )
}
